import { render, staticRenderFns } from "./registered.vue?vue&type=template&id=478fbb04&scoped=true&"
import script from "./registered.vue?vue&type=script&lang=js&"
export * from "./registered.vue?vue&type=script&lang=js&"
import style0 from "./registered.vue?vue&type=style&index=0&id=478fbb04&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478fbb04",
  null
  
)

export default component.exports